import {useState, useEffect, useRef} from 'react';


/** 커스텀 훅: 인증 타이머 로직
 * isCodeSent prop이 true가 되면 3분(180초) 타이머를 시작하며, 남은 시간( timer)과 "MM:SS" 형식의 문자열( formattedTime)을 반환
 * '재전송' 클릭 시 타이머를 리셋하는 handleResendClick 함수를 제공
 * */
function useVerificationTimer(isCodeSent) {
    const [timer, setTimer] = useState(180); // 3분
    const [formattedTime, setFormattedTime] = useState('03:00');
    const intervalRef = useRef(null);

    // 타이머 시작
    const startTimer = () => {
        clearInterval(intervalRef.current); // 기존 타이머 정리
        setTimer(180);
        setFormattedTime('03:00');

        intervalRef.current = setInterval(() => {
            setTimer(prevTimer => {
                const nextTimer = prevTimer - 1;
                if (nextTimer > 0) {
                    const minutes = Math.floor(nextTimer / 60);
                    const seconds = nextTimer % 60;
                    setFormattedTime(
                        `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
                    );
                    return nextTimer;
                } else {
                    clearInterval(intervalRef.current);
                    setFormattedTime('00:00');
                    return 0;
                }
            });
        }, 1000);
    };

    // 함수: 재전송 클릭
    const handleResendClick = () => {
        // TODO: 서버로 재전송 API 호출
        startTimer(); // 타이머 리셋
    };

    // Effect: isCodeSent가 true가 되면 타이머 시작
    useEffect(() => {
        if (isCodeSent) {
            startTimer();
        } else {
            clearInterval(intervalRef.current);
        }

        // 컴포넌트 언마운트 시 타이머 정리
        return () => clearInterval(intervalRef.current);
    }, [isCodeSent]);

    return {timer, formattedTime, handleResendClick};
}

export default useVerificationTimer;